import S_base from '@/services/wasaapi/__base';

export default {
  async index() {
    const res = await S_base.index({modelName: 'question_type'});
    return res;
  }
}